import type { SVGProps } from 'react'

export function MessageIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="m16 23.41a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
          stroke="currentColor"
          strokeWidth="3"
          fill="none"
        />
        <path
          d="m32 23.41a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
          stroke="currentColor"
          strokeWidth="3"
          fill="none"
        />
        <path
          d="m48 23.41a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
          stroke="currentColor"
          strokeWidth="3"
          fill="none"
        />
        <path
          d="m53 7.41h-42a11 11 0 0 0 -11 11v18a11 11 0 0 0 11 11 1 1 0 0 1 1 1v5.17a3 3 0 0 0 5.12 2.12l7.11-7.12a4 4 0 0 1 2.83-1.17h25.94a11 11 0 0 0 11-11v-18a11 11 0 0 0 -11-11zm9 29a9 9 0 0 1 -9 9h-25.93a6 6 0 0 0 -4.24 1.76l-7.11 7.12a1 1 0 0 1 -1.72-.71v-5.17a3 3 0 0 0 -3-3 9 9 0 0 1 -9-9v-18a9 9 0 0 1 9-9h42a9 9 0 0 1 9 9z"
          stroke="currentColor"
          strokeWidth="3"
          fill="none"
        />
      </g>
    </svg>
  )
}
